import styled from 'styled-components';

import units from '@/styles/js/units';

export const Menu = styled.section`
  top: env(safe-area-inset-top);
  position: sticky;
  z-index: ${units.zIndex.menu};
`;
